<template>
	<div>
		<modalconfirm ref="modalApprove" @action="approveConvertSerial"/>
		<ModalAddSerial ref="ModalAddSerial" :type="serial_type" :name="product_name" :serial_from="serial_from" @saveSerial="saveSerial"/>
		<div class="text-h5">Approval Penukaran Serial</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form ref="formAddSDO">
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-autocomplete item-value="serial_convert_code" v-model="serial_convert_code" :items="listSerialConvert" label="Penukaran Serial" outlined dense class="width-0" :rules="[inputrules.required]" no-data-text="Tidak ada data yang sesuai" :filter="customFilter">
										<template v-slot:item = {item}>
											{{item.serial_convert_code}} - {{item.serial_convert_network_code}} - {{item.customer_name}}
										</template>
										<template v-slot:selection = {item}>
											{{item.serial_convert_code}}
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>                        
						<v-col cols="12" sm="12" md="12">
							<v-row v-if="Object.keys(detailSerialConvert).length > 0">
								<v-col cols="4" class="py-0">
									<div class="text-subtitle-2 font-weight-bold">Mitra</div>
									<div class="text-body-2">{{ detailSerialConvert.serial_convert_network_code }} - {{ detailSerialConvert.customer_name }}</div>
								</v-col>
								<v-col cols="5" class="py-0">
									<div class="text-subtitle-2 font-weight-bold">Alamat</div>
									<div class="text-body-2">{{ addressText(detailSerialConvert) }}</div>
								</v-col>
								<v-col cols="3" class="py-0">
									<div class="text-subtitle-2 font-weight-bold">Platform Request</div>
									<div class="text-body-2">{{ detailSerialConvert.serial_convert_from }} - {{ detailSerialConvert.serial_convert_type == 'mobile_counter' ? 'MB' : 'GS' }}</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="detailSerialConvert.serial_convert_detail" hide-default-footer no-data-text="Tidak ada data tersedia" class="white-row custom-table table-w-100">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.serial_convert_detail_to_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.serial_convert_detail_to_product_code }}</div>
								</template>
								<template v-slot:item.price="{ item }">
									<div class="pt-2">{{ item.serial_convert_detail_to_product_price | toNumber }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<div class="pt-2">{{ item.serial_convert_detail_quantity | toNumber }}</div>
								</template>
								<template v-slot:item.card_type="{ item }">
									<v-radio-group v-model="item.card_type" row @change="item.serial = []" :disabled="detailSerialConvert.customer_trx_method != 'system'">
										<v-radio label="Fisik" value="fisik"></v-radio>
										<v-radio label="Digital" value="digital"></v-radio>
									</v-radio-group>
								</template>
								<template v-slot:item.is_serial="{ item }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn @click="showModalSerial(item)" fab dark x-small depressed color="green darken-1">
												<v-icon dark>mdi-plus</v-icon>
											</v-btn>
										</template>
										<span v-if="!item.card_type">Silahkan Pilih Tipe Serial</span>
										<span v-else>Tambah Serial</span>
									</v-tooltip>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :disabled="!serial_convert_code" depressed @click="confirmProses" class="text-capitalize">
					<div>Proses</div>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import ModalAddSerial from '@/views/MLwarehouse/serialConvert/ModalAddSerial'

export default {
	inject: ['theme'],
	components: {
		ModalAddSerial
	},
	data() {
		return {
			serial_convert_code: '',
			note: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', width: "10%", sortable: false},
			{ text: 'Harga (Rp)', value: 'price', width: "15%", align: 'end'},
			{ text: 'Jumlah', value: 'quantity', width: "15%", align: 'center'},
			{ text: 'Tipe Serial', value: 'card_type', width: "15%"},
			{ text: 'Serial', value: 'is_serial', width: "10%"},
			],
			serial_type: '',
			card_type: '',
			product_name: '',
			product_id: '',
			serial_from: '',
		}
	},
	computed: {
		...mapGetters('so', ['productSO']),
		...mapState('serialConvert', ['listSerialConvert' , 'detailSerialConvert', 'response', 'responseError', 'alertMultiple', 'OptionFreeTools']),
	},
	methods: {
		...mapActions('serialConvert', ['getSerialConvertRoam', 'approveSerialConvert', 'getDetailSerialConvert', 'scanSerial']),
		...mapMutations('serialConvert', ['saveResponse', 'clearDataSerialConvert', 'setDetailSerialConvert']),
		...mapMutations(['setSnackbar', 'setOverlay']),

		showModalSerial(item) {
			if (item.card_type) {
				this.serial_type = item.serial_convert_detail_to_product_is_serial
				this.card_type = item.card_type
				this.product_id = item.serial_convert_detail_to_product_id
				this.product_name = item.serial_convert_detail_to_product_name
				this.serial_from = item.serial_convert_detail_from_serial
				this.$refs.ModalAddSerial.showModal()
				this.$refs.ModalAddSerial.updateSerial(item.serial)
			}
		},
		async saveSerial(data) {
			let indexProduct = await this.detailSerialConvert.serial_convert_detail.findIndex(el => el.serial_convert_detail_to_product_id == this.product_id);
			let serialArray = []
			await this.detailSerialConvert.serial_convert_detail.forEach( el => {
				if (el.serial_convert_detail_to_product_product_id == this.product_id) {
					serialArray = [... serialArray, ... el.serial]
				}
			});

			await this.scanSerial({
				serial: data,
				type: this.serial_type,
				card_type: this.card_type,
				arr_serial: serialArray,
			}).then((serial) => {
				let product = this.detailSerialConvert.serial_convert_detail[indexProduct]
				let unique = new Set([... product.serial, ... serial.success])
				if (product.serial_convert_detail_quantity >= (product.serial.length + serial.success.length)) {
					product.serial = [... unique]
					this.detailSerialConvert.serial_convert_detail[indexProduct].serial = product.serial
					this.$refs.ModalAddSerial.updateSerial(product.serial)
					this.setSnackbar({
						show: true,
						color: 'success',
						text: `Berhasil scan serial`
					})
				} else {
					if (serial.success.length > 0) {
						product.serial = [... unique]
						this.detailSerialConvert.serial_convert_detail[indexProduct].serial = product.serial.slice(0, product.serial_convert_detail_quantity)
						this.$refs.ModalAddSerial.updateSerial(product.serial)
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: `Jumlah serial yang diproses disesuaikan`
						})
					} else {
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: 'Gagal scan serial'
						})
					}
				}
				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
			}).catch((serial) => {
				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: 'Gagal scan serial'
				})
			})
		},
		customFilter (item, queryText) {
			const textOne = item.serial_convert_code.toLowerCase()
			const textTwo = item.serial_convert_network_code.toLowerCase()
			const textThree = item.customer_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1
		},
		confirmProses(){
			if (this.$refs.formAddSDO.validate()) {
				let msg = "Yakin akan memproses pengiriman ini?"
				this.$refs.modalApprove.setMessage(msg)
				this.$refs.modalApprove.showConfirm()
			}
		},
		async approveConvertSerial() {
			await this.setOverlay(true)
			await this.$refs.modalApprove.hideConfirm()
			let product = this.detailSerialConvert.serial_convert_detail.map(el => {
				return {
					product_id: el.serial_convert_detail_to_product_id,
					serial: el.serial
				}
			})
			let params = await {
				serial_convert_id: this.detailSerialConvert.serial_convert_id,
				// note: this.note,
				product: product,
			}
			
			await this.approveSerialConvert(params).then(() => {
				if (this.response.code == 200) {
					this.resetData()
					this.getSerialConvertRoam()
				}
			})
			await this.setOverlay(false)
		},
        addressText(value) {
			var data = []
			if (value.customer_address)
				data.push(value.customer_address)
			if (value.customer_subdistrict_name)
				data.push(value.customer_subdistrict_name)
			if (value.customer_city_name)
				data.push(value.customer_city_name)
			if (value.customer_province_name)
				data.push(value.customer_province_name)
			return data.join(', ')
		},
		resetData() {
			this.serial_convert_code = ''
			this.note = ''
			this.setDetailSerialConvert({})
			this.$refs.formAddSDO.resetValidation()
			this.saveResponse({})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Penukaran Serial`)
		this.getSerialConvertRoam().then( () => {
			if (this.$route.params.code) {
				this.serial_convert_code = this.$route.params.code
				this.getDetailSerialConvert(this.$route.params.code)
			}
		})
	},
	beforeDestroy(){
		this.clearDataSerialConvert()
	},
	watch: {
        serial_convert_code(val) {
			if (val) {
				this.getDetailSerialConvert(val)
			} else {
				this.setDetailSerialConvert({})
			}
			this.free_tools = false
			this.upgrade = false
		}
	}
}
</script>